module.exports = __webpack_public_path__ + "assets/polyfill.39c88e1a.svg";